export default __webpack_public_path__ + "static/media/brand_light.0dcb3622.png";